/**
 * 浏览器标题未读消息提示工具
 */
class TitleNotifier {
  constructor() {
    this.originalTitle = document.title;
    this.timer = null;
    this.unreadCount = 0;
  }

  /**
   * 更新未读消息数量
   * @param {number} count - 未读消息数量
   */
  updateCount(count) {
    this.unreadCount = count;
    
    // 停止之前的定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if (count > 0) {
      // 开始闪烁
      let showUnread = true;
      this.timer = setInterval(() => {
        if (showUnread) {
          document.title = `(${count}条未读) ${this.originalTitle}`;
        } else {
          document.title = this.originalTitle;
        }
        showUnread = !showUnread;
      }, 1000);
    } else {
      // 恢复原标题
      document.title = this.originalTitle;
    }
  }

  /**
   * 清除未读提示
   */
  clear() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.unreadCount = 0;
    document.title = this.originalTitle;
  }
}

// 创建单例
const titleNotifier = new TitleNotifier();

// 监听页面可见性变化，页面激活时清除提示
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    titleNotifier.clear();
  }
});

// 监听窗口焦点，获得焦点时清除提示
window.addEventListener('focus', () => {
  titleNotifier.clear();
});

export default titleNotifier;
